"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _rem = _interopRequireDefault(require("polished/lib/helpers/rem"));

var _styledComponents = _interopRequireWildcard(require("styled-components"));

var _styledComponentsModifiers = require("styled-components-modifiers");

var _color = _interopRequireDefault(require("../../modifiers/color"));

var _utils = require("../../utils");

var _commonUIColors = require("../../utils/commonUIColors");

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) { var desc = Object.defineProperty && Object.getOwnPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : {}; if (desc.get || desc.set) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } } newObj.default = obj; return newObj; } }

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var makeSizeModifiers = function makeSizeModifiers(_ref) {
  var size = _ref.size,
      border = _ref.border;
  return (0, _styledComponents.css)(["height:", ";min-height:", ";width:", ";min-width:", ";border:", " solid white};"], (0, _rem.default)(size), (0, _rem.default)(size), (0, _rem.default)(size), (0, _rem.default)(size), (0, _rem.default)(border));
};

var sizeModifiers = {
  medium: function medium() {
    return makeSizeModifiers({
      size: 10,
      border: 1
    });
  },
  large: function large() {
    return makeSizeModifiers({
      size: 14,
      border: 1
    });
  }
};
var colorModifiers = (0, _utils.applyDynamicModifiers)('color', function (_ref2) {
  var color = _ref2.color;
  return (0, _styledComponents.css)(["", ""], color && color in _commonUIColors.commonUIColors && (0, _color.default)(_commonUIColors.commonUIColors[color]));
});

var AvatarIndicator = _styledComponents.default.div.withConfig({
  displayName: "AvatarIndicator",
  componentId: "sc-1jxc2yq-0"
})(["position:absolute;width:", ";height:", ";border:1px solid white;border-radius:50%;bottom:0;right:0;", " ", ""], (0, _rem.default)(10), (0, _rem.default)(10), (0, _styledComponentsModifiers.applyStyleModifiers)(sizeModifiers, 'size'), colorModifiers);

var _default = AvatarIndicator;
exports.default = _default;